<template>
  <div v-if="currentSession">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Formations'"
          :description="'Aperçu d\'une session de formation'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentSession.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between">
                    <span>
                      Intitulé de la formation :
                      {{ currentSession.formation.intitule }}
                    </span>
                    <span>
                      <router-link
                        title="Aperçu"
                        :to="{
                          name: 'rh_formation-show',
                          params: { id: currentSession.formation.id },
                        }"
                        class="mr-4"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                        Aperçu
                      </router-link>
                    </span>
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence :
                    {{ currentSession.formation.reference }}
                  </td>
                  <td class="col-6">
                    Durée :
                    {{ currentSession.formation.duree + ' H' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence :
                    {{ currentSession.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="{
                        'text-warning':
                          currentSession.statut === 0 ||
                          currentSession.statut === 5,
                        'text-danger': currentSession.statut === 3,
                        'text-success':
                          currentSession.statut === 1 ||
                          currentSession.statut === 2 ||
                          currentSession.statut === 4,
                      }"
                    ></i>
                    {{ getStatutSession(currentSession.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push(sprov).catch(() => {})"
        >
          Liste des sessions de formation
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_formation_session-create',
                params: {
                  formationId: currentSession.formation.id,
                  sprov: sprov,
                },
              })
              .catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle session de formation
        </button>
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'rh_formation_session-edit',
                params: { sessionId: currentSession.id, sprov: sprov },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-custom-primary"
          @click="showModalStatut"
        >
          Changer le statut
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'rh_formation_session-show',
                params: { sessionId: currentSession.id, sprov: sprov },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Session de formation</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'rh_formation_session_show-document',
                params: {
                  sessionId: currentSession.id,
                  documentUuid: currentSession.document.uuid,
                  sprov: sprov,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_formation_session_show_participation',
                params: {
                  sessionId: currentSession.id,
                  sprov: sprov,
                },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Demandes de participations</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_formation_session_show_presence',
                params: {
                  sessionId: currentSession.id,
                  sprov: sprov,
                },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Contrôle de presence</b-nav-item
            >
            <!--b-nav-item
              :to="{
                name: 'rh_formation_session_show_agenda',
                params: {
                  id: currentSession.id,
                },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Agenda</b-nav-item
            -->
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
    <ModalStatut
      ref="modalStatut"
      :currentSession="currentSession"
      @onChangeStatut="onChangeStatut"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import ModalStatut from '../components/ModalStatut.vue';
export default {
  data() {
    return {
      sprov: this.$route.params.sprov,
      reload: true,
    };
  },
  computed: {
    ...mapGetters('formationSession', ['currentSession']),
  },
  components: {
    ModalStatut,
  },

  watch: {
    reload: {
      immediate: true,
      handler(val) {
        if (val) this.init();
      },
    },
  },
  methods: {
    ...mapActions('formationSession', ['getSession', 'setCurrentSession']),
    showModalStatut() {
      this.$refs.modalStatut.showModal();
    },
    onChangeStatut(session) {
      this.setCurrentSession(session);
    },
    init() {
      this.getSession({ id: this.$route.params.sessionId, edit: false });
      this.reload = false;
    },
  },
};
</script>
